import axiosHttp from "axios";
import { Notification } from "element-ui";
import router from '../router'
import store from '../stores/index.js'
import { getAuthToken } from './authSession.js'

let base = store.state.base;
axiosHttp.defaults.withCredentials = true;
// POST 方法封装  (参数处理)
export const postFormRequest = (url, params, callback, errCallback) => {
  axiosHttp({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    if(checkCode(res, errCallback)) {
      callback(res.data);
    }
  });
}

export const postRequest = (url, params, callback, errCallback, successNotify) => {
  axiosHttp({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
  }).then(res => {
    if(checkCode(res, errCallback, successNotify)) {
      callback(res.data);
    }
  }).catch(err => {
    if (typeof errCallback === 'function') {
      const data = (err && err.response && err.response.data) ? err.response.data : {};
      if (!data.message && err && err.message) {
        data.message = err.message;
      }
      errCallback(data);
    }
  });
}

// POST 方法封装  (文件上传)
export const uploadFileRequest = (url, params, callback, errCallback) => {
  axiosHttp({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if(checkCode(res, errCallback)) {
      callback(res.data);
    }
  });
}

//  GET 方法封装
export const getRequest = (url, callback, errCallback) => {
  axiosHttp({
    method: 'get',
    url: `${base}${url}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then(res => {
    if(checkCode(res, errCallback, true)) {
      callback(res.data);
    }
  }).catch((err) => {
    if (typeof errCallback === 'function') {
      errCallback(err);
    }
  });
}

/**
 * GET 返回 Promise：成功 resolve 整段业务 JSON（与 getRequest 的 callback 入参一致），失败 reject。
 * 用于分页拉取等必须结束 loading 的场景；不在成功时弹绿色提示。
 */
export const getRequestPromise = (url) => {
  return axiosHttp({
    method: 'get',
    url: `${base}${url}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    withCredentials: true,
  }).then((res) => {
    normalizeAxiosJsonBody(res);
    const d = res.data;
    const ok = d && (
      d.code === 200
      || d.errorCode === 0
      || d.errorCode === '0'
      || d.errorCode === 103
    );
    if (ok) {
      return d;
    }
    if (d && (d.code === 10003 || d.code === 10004 || d.errorCode === 102)) {
      Notification.error({
        message: (d.message ? d.message : d.description) || '未登录',
        offset: 50,
      });
      window.localStorage.setItem('Y_REMENBERME', false);
      window.location.href = '/';
      return Promise.reject(d);
    }
    Notification.error({
      message: (d && (d.message || d.description)) || '请求失败',
      offset: 50,
    });
    return Promise.reject(d || new Error('请求失败'));
  });
}

export const downloadFile = (url, callback, errCallback) => {
  axiosHttp({
    method: 'get',
    url: `${url}`,
    responseType: 'blob',
    headers: {
      'Content-Type': 'audio/mpeg;charset=UTF-8'
    }
  }).then(res => {
    callback(res.data);
  });
}


//  PUT 方法封装
export const putFormRequest = (url, params, callback, errCallback) => {
  return axiosHttp({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then(res => {
    if(checkCode(res, errCallback)) {
      callback(res.data);
    }
  });
}

export const putRequest = (url, params, callback, errCallback, successNotify) => {
  axiosHttp({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then(res => {
    if(checkCode(res, errCallback, successNotify)) {
      callback(res.data);
    }
  });
}

//  DELETE 方法封装
export const deleteRequest = (url, callback, errCallback) => {
  axiosHttp({
    method: 'delete',
    url: `${base}${url}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then(res => {
    if(checkCode(res, errCallback)) {
      callback(res.data);
    }
  });
}


//  REQUEST 请求异常拦截
axiosHttp.interceptors.request.use(config=> {
  config.headers.Auth = getAuthToken();
  return config;
}, err=> {
  //==================  错误处理  ====================
  //Message.error({message: '请求超时!'});
  Notification.error({
    message: '408 Request Timeout',
    offset: 50
  })
  return Promise.reject(err);
})

//请求返回拦截
axiosHttp.interceptors.response.use(response => {
    return Promise.resolve(response);
  },
  error => {
    checkStatus(error)
    return Promise.reject(error)
  }
)

// http状态码错误处理
const checkStatus = (err) => {
  console.log(err);
  if (err && err.response) {
    switch (err.response.status) {
      case 400: err.message = '400 Bad Request'; break;
      case 401: err.message = '401 Unauthorized'; break;
      case 403: err.message = '403 Forbidden'; break;
      case 404: err.message = '404 Not Found'; break;
      case 408: err.message = '408 Request Timeout'; break;
      case 500: err.message = '500 Internal Server Error'; break;
      case 501: err.message = '501 Not Implemented'; break;
      case 502: err.message = '502 Bad Gateway'; break;
      case 503: err.message = '503 Service Unavailable'; break;
      case 504: err.message = '504 Gateway Timeout'; break;
      case 505: err.message = '505 HTTP Version Not Supported'; break;
      default: err.message = `Error (${err.response.status})。`;
    }
  } else {
    err.message = '连接服务器失败。'
  }
  //Message.error( {message: err.message } )
  Notification.error({
    message: err.message,
    offset: 50
  })
}

/** 部分接口以 text 返回 JSON 字符串，axios 不会自动解析，会导致 checkCode 误判失败 */
function normalizeAxiosJsonBody(res) {
  if (!res || res.data == null) {
    return;
  }
  if (typeof res.data !== 'string') {
    return;
  }
  const s = res.data.trim();
  if (!s || (s[0] !== '{' && s[0] !== '[')) {
    return;
  }
  try {
    res.data = JSON.parse(s);
  } catch (e) {
    /* 保持原样 */
  }
}

// 后台自定义 code错误处理
const checkCode = (res, errCallback, successNotify) => {
  if(res){
    normalizeAxiosJsonBody(res);
    const d = res.data;
    const ok = d && (
      d.code === 200
      || d.errorCode === 0
      || d.errorCode === '0'
      || d.errorCode === 103
    );
    if(ok){       //code为0成功 103修改密码成功，重新登录
      if(!successNotify) {
        const nested = d.data
        const nestedMsg = nested && typeof nested === 'object' && !Array.isArray(nested) && nested.message
        Notification.success({
          message: (d.message || nestedMsg || d.description),
          offset: 50
        })
      }
      return true
    } else if(d.code === 10003 || d.code === 10004 || d.errorCode === 102) {
      Notification.error({
        message: (d.message ? d.message : d.description),
        offset: 50
      })
      // 让 getRequest 等调用方结束 Promise / loading，避免会话失效时回调永不触发而一直转圈
      if (typeof errCallback === 'function') {
        errCallback(d);
      }
      //请求过期等，需要跳转到登录页
      window.localStorage.setItem("Y_REMENBERME", false);
      //router.push("/").then(r => {return true});
      window.location.href = "/";
      return false;
    } else {
      if(errCallback) {
        errCallback(d);
        return false;
      } else {
        Notification.error({
          message: (d.message ? d.message : d.description),
          offset: 50
        })
        return false;
      }
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/http.js